import React from "react"
import { Link } from "react-router-dom"
import logo from "./WaveSaleslandingpage/img/logo.png"

export default function PoliticaPrivacidad() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      {/* Header con logo */}
      <header className="bg-gray-900/50 backdrop-blur-sm border-b border-gray-700 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src={logo} alt="WaveSales" className="h-10 w-auto" />
            <span className="text-xl font-bold text-white">WaveSales</span>
          </Link>
          <Link 
            to="/" 
            className="text-gray-300 hover:text-white transition-colors text-sm"
          >
            ← Volver al inicio
          </Link>
        </div>
      </header>

      {/* Contenido principal */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white/5 backdrop-blur-md rounded-2xl border border-gray-700/50 shadow-2xl p-8 md:p-12">
          <h1 className="text-4xl font-bold text-white mb-2">
            Política de Privacidad
          </h1>
          <p className="text-gray-400 text-sm mb-8">
            Última actualización: 18/11/2025
          </p>

          <div className="prose prose-invert max-w-none space-y-6 text-gray-300">
            <p className="text-gray-300 leading-relaxed">
              <strong className="text-white">WaveSales</strong> (en adelante "WaveSales", "nosotros", "nuestro"), con domicilio en <strong className="text-white">Santa Lucia y De Los Helechos, Quito - Ecuador, Código Postal: 170138</strong>, con sitio web{" "}
              <a href="https://wave-sales.com" className="text-indigo-400 hover:text-indigo-300 transition-colors">
                https://wave-sales.com
              </a>
              , se compromete a proteger la privacidad de las personas que interactúan con nuestros servicios. Esta Política describe qué datos recopilamos, por qué los usamos, con quién los compartimos y cómo puedes ejercer tus derechos.
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">1. Información que recopilamos</h2>
              
              <h3 className="text-xl font-semibold text-white mt-6 mb-3">1.1 Información que nos das directamente</h3>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>Nombre, apellidos, correo electrónico, teléfono.</li>
                <li>Datos de la empresa: razón social, RUC/ID, dirección, correo corporativo.</li>
                <li>Información de facturación: dirección fiscal, datos de pago (procesados por pasarelas externas).</li>
                <li>Credenciales de acceso y configuración de cuenta en WaveSales.</li>
              </ul>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3">1.2 Información recopilada automáticamente</h3>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>Dirección IP, tipo de dispositivo, datos de navegador, identificadores de sesión, registros de acceso y actividad en la plataforma.</li>
                <li>Cookies y tecnologías similares (ver Política de Cookies).</li>
              </ul>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3">1.3 Información proveniente de integraciones de terceros</h3>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>Datos recibidos por integraciones que habilitas (por ejemplo Meta / WhatsApp Business): business_id, phone_number_id, estado de plantillas, métricas de mensajería, etc.</li>
                <li>Tokens de acceso que el propio cliente autoriza; WaveSales no utiliza esos tokens para fines distintos al servicio contratado.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">2. Finalidades del tratamiento</h2>
              <p className="text-gray-300 leading-relaxed mb-3">Tratamos datos para:</p>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>Proveer y operar la plataforma WaveSales.</li>
                <li>Gestionar integraciones con terceros (p. ej. WhatsApp Cloud API).</li>
                <li>Enviar notificaciones y comunicaciones relacionadas al servicio.</li>
                <li>Facturación y gestión de cobros (o enlace con procesadores de pago).</li>
                <li>Análisis, mejora del servicio y seguridad.</li>
                <li>Cumplir obligaciones legales y regulatorias.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">3. Base legal</h2>
              <p className="text-gray-300 leading-relaxed mb-3">Dependemos de las siguientes bases:</p>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li><strong className="text-white">Consentimiento</strong> para comunicaciones comerciales cuando lo otorgues.</li>
                <li><strong className="text-white">Ejecución del contrato</strong> para la prestación del servicio.</li>
                <li><strong className="text-white">Interés legítimo</strong> para seguridad, mejora de producto y prevención de fraude.</li>
                <li><strong className="text-white">Cumplimiento legal</strong> cuando proceda.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">4. Conservación de datos</h2>
              <p className="text-gray-300 leading-relaxed">
                Conservamos datos mientras exista la cuenta activa y durante el plazo necesario para cumplir obligaciones legales o contractuales. Tras ello, se eliminan o anonimizarán para análisis.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">5. Cesión y transferencias</h2>
              <p className="text-gray-300 leading-relaxed mb-3">Podemos compartir datos con:</p>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>Proveedores de servicios (hosting, soporte, procesadores de pago, analítica).</li>
                <li>Meta Platforms Inc., únicamente en el contexto de las integraciones que autorices.</li>
                <li>Autoridades públicas cuando exista obligación legal.</li>
              </ul>
              <p className="text-gray-300 leading-relaxed mt-3">
                Siempre bajo acuerdos de confidencialidad y medidas técnicas.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">6. Seguridad</h2>
              <p className="text-gray-300 leading-relaxed">
                Implementamos medidas técnicas y organizativas razonables para proteger la información. No obstante, ningún sistema es 100% seguro.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">7. Derechos del titular</h2>
              <p className="text-gray-300 leading-relaxed">
                Puedes solicitar: <strong className="text-white">acceso, rectificación, supresión, limitación, oposición y portabilidad</strong>. Solicitudes a:{" "}
                <a href="mailto:soporte@wave-sales.com" className="text-indigo-400 hover:text-indigo-300 transition-colors">
                  soporte@wave-sales.com
                </a>
                . Responderemos en un plazo máximo de 30 días.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">8. Uso específico con Meta / WhatsApp Business</h2>
              <p className="text-gray-300 leading-relaxed mb-3">Cuando conectas tu WhatsApp Business cuenta a WaveSales:</p>
              <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                <li>Tú controlas la cuenta y los métodos de pago en Meta; WaveSales actúa como proveedor tecnológico.</li>
                <li>WaveSales no realiza cobros por mensajes en tu cuenta de WhatsApp Business; los cargos por mensajes/plantillas son facturados por Meta a tu cuenta, salvo acuerdo distinto.</li>
                <li>WaveSales usará tokens autorizados por el cliente exclusivamente para operar la integración.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">9. Cookies</h2>
              <p className="text-gray-300 leading-relaxed">
                Usamos cookies para sesiones, rendimiento, analítica y publicidad (ver{" "}
                <Link to="/politica-de-cookies" className="text-indigo-400 hover:text-indigo-300 transition-colors">
                  Política de Cookies
                </Link>
                ).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">10. Cambios en la política</h2>
              <p className="text-gray-300 leading-relaxed">
                Actualizaciones se publicarán en esta página con fecha de última revisión.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">11. Contacto</h2>
              <p className="text-gray-300 leading-relaxed">
                Si tienes dudas o quieres ejercer tus derechos:{" "}
                <a href="mailto:soporte@wave-sales.com" className="text-indigo-400 hover:text-indigo-300 transition-colors">
                  soporte@wave-sales.com
                </a>
              </p>
              <p className="text-gray-300 leading-relaxed mt-2">
                Sitio web:{" "}
                <a href="https://wave-sales.com" className="text-indigo-400 hover:text-indigo-300 transition-colors">
                  https://wave-sales.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer simple */}
      <footer className="bg-gray-900/50 border-t border-gray-700 py-8 mt-12">
        <div className="max-w-6xl mx-auto px-6 text-center text-gray-400 text-sm">
          <p>© 2025 WaveSales. Todos los derechos reservados.</p>
          <div className="mt-4 flex items-center justify-center gap-6">
            <Link to="/terminos-y-condiciones" className="hover:text-white transition-colors">
              Términos y condiciones
            </Link>
            <Link to="/politica-de-privacidad" className="hover:text-white transition-colors">
              Política de privacidad
            </Link>
            <Link to="/politica-de-cookies" className="hover:text-white transition-colors">
              Política de Cookies
            </Link>
          </div>
        </div>
      </footer>
    </div>
  )
}
